import React from 'react';
import './HorizontalRule.scss';

const HorizontalRule = ({ hideResponsive = false }) => {
  return <div className={hideResponsive ? 'hidden-responsive horizontal-rule' : 'horizontal-rule'}></div>
}

export default HorizontalRule;
